export const MAP_API_KEY = 'AIzaSyAuTVpqdhOjXImD9o_pBPWRm2WL0hMf1Qk';
